import Instance from '../../../Axios';

const RemoverUnidade = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .delete(`/backend/unidades/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'DELETE_UNIDADE', payload: data });
    })
    .catch(({ err }) => console.log(err));
};

export default RemoverUnidade;
